import { render, staticRenderFns } from "./announcementList.vue?vue&type=template&id=548635aa"
import script from "./announcementList.vue?vue&type=script&lang=js"
export * from "./announcementList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports